function PartitaIvaCee(partitaIvaCee, companyCountry) {
    this.partitaIvaCee = partitaIvaCee;
    this.companyCountry = companyCountry;
}

PartitaIvaCee.prototype.isValid = function () {
    var isValid = false;

    var nazione = new Nazione(this.companyCountry);
    if (this.partitaIvaCee.toUpperCase().startsWith(nazione.IsoCode())) {
        var nazioneIvaLunghezze = nazione.IvaLunghezze();
        for (var i = 0; i < nazioneIvaLunghezze.length; i++) {
            if (nazioneIvaLunghezze[i] == this.partitaIvaCee.length) {
                isValid = true;
            }
        }
    }

    return isValid;
}

